import {
    Button, FormControl, FormErrorMessage, FormLabel, Input, Textarea
} from "@chakra-ui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import axios from "axios";
import { Field, Form, Formik } from 'formik';
import { Store } from 'react-notifications-component';

export default function FormDao(props) {
    const { address } = useGetAccountInfo();
    const edit = props.edit;
    const initialValues = props.data || { title: '', description: '', userWalletAddress: address }

    function onSubmit(values, actions) {
        setTimeout(async() => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/proposals`, values, {
                headers: {
                    signature: localStorage.getItem("signature")
                }
            })
            .then(() => {
                Store.addNotification({
                    title: "Proposition successfully created 🚀",
                    message: "Waiting for admin approval to see it",
                    type: "success",
                    insert: "top",
                    container: "bottom-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        pauseOnHover: true
                    }
                });
            })
            .catch(error => {
                Store.addNotification({
                    title: "Proposition not submitted",
                    message: error.response.data.message,
                    type: "danger",
                    insert: "top",
                    container: "bottom-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        pauseOnHover: true
                    }
                });
            })
            const data = response?.data;
            actions.setSubmitting(false);
            props.setisMutating(true);
            props.onClose();
        }, 500)
    }

    function validateTitle(value) {
        let error
        if (!value) {
            error = "Name your proposition"
        }
        return error
    }

    function validateDesc(value) {
        let error
        if (!value) {
            error = "Describe your proposition"
        }
        return error
    }
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}

        >
            {(props) => (
                <Form>
                    <Field name="title" validate={validateTitle}>
                        {({ field, form }) => (
                            <FormControl isInvalid={form.errors.title && form.touched.title}>
                                <FormLabel htmlFor="title">Title</FormLabel>
                                <Input
                                    {...field}
                                    id="title"
                                    fontFamily={'body'}
                                    placeholder="Go to the moon"
                                    borderRadius="16px"
                                    color={'whiteAlpha.800'}
                                    disabled={!edit}
                                />
                                <FormErrorMessage>{form.errors.title}</FormErrorMessage>
                            </FormControl>
                        )}
                    </Field>
                    <Field name="description" validate={validateDesc}>
                        {({ field, form }) => (
                            <FormControl mb={4} mt={4} isInvalid={form.errors.description && form.touched.description}>
                                <FormLabel htmlFor="description">Description</FormLabel>
                                <Textarea
                                    {...field}
                                    id="description"
                                    fontFamily={'body'}
                                    placeholder="Buy spaceship and go to the moon"
                                    borderRadius="16px"
                                    color={'whiteAlpha.800'}
                                    disabled={!edit}
                                />
                                <FormErrorMessage>{form.errors.description}</FormErrorMessage>
                            </FormControl>
                        )}
                    </Field>
                    {edit &&
                        <Button
                            mb={4}
                            className='btn-secondary'
                            isLoading={props.isSubmitting}
                            type="submit"
                            color={'white'}
                        >
                            Submit proposition
                        </Button>
                    }
                </Form>
            )}
        </Formik>
    )
}
